//Aqui se defiene las variables para el control y manejo de los input
export const initialForm = {
  selectDoc: '',
  typeDoc: '',
  password: '',
}

export const optionPhone = [
  { id: 1, name: "Seleccione" },
  { id: 2, name: "0414" },
  { id: 3, name: "0424" },
  { id: 4, name: "0412" },
  { id: 5, name: "0426" },
  { id: 6, name: "0416" },
];


export const optionTarjeta = [
  { id: 1, name: 'Seleccione' },
  { id: 2, name: 'Visa' },
  { id: 3, name: 'Master Card' },
  { id: 3, name: 'Diners Club' },

];

export const optionTipoDoc = [
  { id: 1, name: "Seleccione" },
  { id: 2, name: "V" },
  { id: 3, name: "E" },
  { id: 4, name: "J" },
  { id: 5, name: "G" },
  { id: 6, name: "P" },
];

export const formDomiciliacion = {
  email: "",
  selectNumber: "",
  phone: "",
  swiftcuenta: "",
  cuentaBancaria: "",
  ctaBancariaAll: "",
  terminos: ""
};

export const formDomiciliacionCredito = {
  nameCredito: "",
  email: "",
  selectNumber: "",
  phone: "",
  numberCardCredit: "",
  tipoTarjeta: "",
  code: "",
  month: "",
  year: "",
  terminos: ""
};
